/* global axios */
import ApiClient from './ApiClient';

class Ga4API extends ApiClient {
  constructor() {
    super('ga4/configs', { accountScoped: true });
  }

  getConfigs() {
    return axios.get(this.url);
  }

  createConfig(payload) {
    return axios.post(this.url, { ga4_config: payload });
  }

  updateConfig(id, payload) {
    return axios.patch(`${this.url}/${id}`, { ga4_config: payload });
  }

  deleteConfig(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  properties(connectionId) {
    return axios.get(`${this.baseUrl()}/ga4/reports/properties`, {
      params: { connection_id: connectionId },
    });
  }

  report(connectionId, propertyId, dateRange) {
    return axios.get(`${this.baseUrl()}/ga4/reports`, {
      params: {
        connection_id: connectionId,
        property_id: propertyId,
        date_range: dateRange,
      },
    });
  }
}

export default new Ga4API();
